import {
  Container,
  Box,
  Button,
  Grid,
  Dialog,
  Card,
  IconButton,
  Typography,
  Checkbox,
  TextField,
  Chip,
  ListItem,
  ListItemIcon,
  List,
  ListSubheader,
  Drawer,
  Stack,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import { Dispatch, Fragment, SetStateAction, useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { SearchComponent } from "../SearchComponent";
import { useNavigate } from "react-router-dom";
import { IProjectData } from "@types";
import { useRecoilState, useSetRecoilState, useRecoilValue } from "recoil";
import {
  selectedProjectState,
  autoFillDataState,
  projectSelectCountState,
  trainingState,
  isTutorialState,
  stepIndexState,
} from "../../recoil";
import CustomButton from "../customComponent/CustomButton";
import { t } from "i18next";
import HighlightBox from "../customComponent/CustomHighlightBox";
import { ArrowBackIcon, CloseIcon, FolderIcon, GridViewIcon, StorageIcon, ViewHeadlineIcon } from "../../icons";
import { toast } from "react-toastify";
import { IDragInfo } from "../../@types";
import FolderModal from "./FolderModal";
import { GridView } from "./GridView";
import { ListView } from "./ListView";
import { func_userConfigUpdate } from "../../utils/tutorialUtil";
import ProductTour from "../joyride/ProductTour";
import { steps_1 } from "../joyride/step1";
import { formatDate, handleSelectChange } from "../../utils/utils";
import DatasetGridView from "./DatasetGridView";
import PageShell from "../new/PageShell";
import { Folder } from "lucide-react";
// import FolderCard from "./FolderCard";
import ProjectCard from "../new/ProjectCard";
import FolderCard from "../new/FolderCard";
import {
  createFolder,
  deleteFolder,
  deleteProject,
  editFolderContents,
  getFolder,
  getFolderContents,
  getFoldersByPath,
  getProjects,
  getUnassignedDataSets,
} from "common-lib";
import { useTutorial } from "../../context/TutorialContext";

interface TriggerNgModalProps {
  open: boolean;
}

function TriggerNgModal({ open }: TriggerNgModalProps) {
  return (
    <>
      <Dialog open={open}> NG 일정수 초과</Dialog>
    </>
  );
}

interface FolderInfoItem {
  folder: FolderSimpleItem;
  child_count: number;
  project_count: number;
}

interface FolderSimpleItem {
  id: number;
  name: string;
  parent: number | null;
  create_at: string;
  update_at: string;
}

export default function ProjectMain() {
  const navigate = useNavigate();
  const [projectsData, setProjectsData] = useState<IProjectData[]>([]); //프로젝트 리스트
  const [folderList, setFolderList] = useState<FolderItem[]>([]); //폴더 리스트
  const setSelectedProject = useSetRecoilState(selectedProjectState); //프로젝트 진입시 선택한 프로젝트
  const [autoFillData, setAutoFillData] = useRecoilState(autoFillDataState);
  const [page, setPage] = useState<number>(1); //페이지
  const [totalCount, setTotalCount] = useState<number>(0); //전체 개수
  const [isCopied, setIsCopied] = useState(false); //복제 여부
  const [projectSelectCount, setProjectSelectCount] = useRecoilState(projectSelectCountState); //설정된 프로젝트 size 개수 (몇개씩 메인에서 보여줄지)
  const [isClick, setIsClick] = useState(false); //클릭 여부
  const [keyword, setKeyword] = useState<string | null>(null); //검색 키워드
  const [checkedProjects, setCheckedProjects] = useState<number[]>([]); //선택된 프로젝트들
  const [checkedFolders, setCheckedFolders] = useState<number[]>([]); //선택된 폴더들
  const [checked, setChecked] = useState<boolean>(false); //상단의 전체 체크
  const [viewType, setViewType] = useState<"grid" | "list">(() =>
    localStorage.getItem("projectViewType") === "grid" ? "grid" : "list",
  ); //뷰 타입 (뒤로가기 시 유지)
  const [isCreatingFolder, setIsCreatingFolder] = useState(false); //폴더 생성 여부
  const [currentPath, setCurrentPath] = useState<string>("/root"); //현재 위치한 경로
  const [currentFolder, setCurrentFolder] = useState<FolderItem>({
    id: -1,
    name: "",
    parent: null,
  }); //현재 위치한 폴더 정보

  const [isDragging, setIsDragging] = useState(false); //드래그중
  const [dragInfo, setDragInfo] = useState<IDragInfo | null>(null); //드래그 위치에 대한 정보
  const [open, setOpen] = useState(false); //폴더 구조 모달 open 여부
  const [openFolderInfo, setOpenFolderInfo] = useState(false);
  const [selectType, setSelectType] = useState<string>("project");
  const { pendingStartRef, startTour, tutorialKey, tutorialKeyRef } = useTutorial();

  // useEffect(() => {
  //   if (!pendingStartRef.current) return;

  //   const waitForElement = () => {
  //     const el = document.querySelector("#project-card");

  //     if (el) {
  //       pendingStartRef.current = false;
  //       startTour(tutorialKeyRef.current);
  //     } else {
  //       requestAnimationFrame(waitForElement);
  //     }
  //   };

  //   waitForElement();
  // }, []);

  useEffect(() => {
    if (pendingStartRef.current) {
      pendingStartRef.current = false;
      startTour(tutorialKeyRef.current);
    }
  }, []);

  useEffect(() => {
    setProjectsData([]);
    setPage(1);
    setIsCreatingFolder(false);
    setCheckedFolders([]);
    setCheckedProjects([]);
    fetchFolders(currentFolder.id);
  }, [currentFolder]);

  const [isRun, setIsRun] = useRecoilState(isTutorialState);
  const [stepIndex, setStepIndex] = useRecoilState(stepIndexState);
  const userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");
  const userConfig = JSON.parse(userInfo.config || "{}");
  const [unassignedList, setUnassignedDataset] = useState<DatasetItem[]>([]);

  const step_1_project_id = 254;
  const step = steps_1;

  const lastCheckedFolder = checkedFolders.at(-1);
  const [folderInfo, setFolderInfo] = useState<FolderInfoItem>({
    child_count: 0,
    project_count: 0,
    folder: {
      id: -1,
      name: "",
      parent: null,
      create_at: "",
      update_at: "",
    },
  });

  const info = [
    { label: "종류", value: "폴더" },
    { label: "위치", value: `${currentPath}` },
    {
      label: "내용",
      value: `폴더 ${folderInfo.child_count}, 파일 ${folderInfo.project_count}`,
    },
    {
      label: "올린 날짜",
      value: `${formatDate(folderInfo.folder.create_at) || ""}`,
    },
    {
      label: "수정한 날짜",
      value: `${formatDate(folderInfo.folder.update_at) || ""}`,
    },
  ];

  useEffect(() => {
    const fetchFolderInfo = async () => {
      if (lastCheckedFolder !== undefined) {
        const response = await getFolder(lastCheckedFolder);
        setFolderInfo(response);
      } else {
        setOpenFolderInfo(false);
      }
    };
    fetchFolderInfo();
  }, [lastCheckedFolder]);

  useEffect(() => {
    fetchProjects();
  }, [page, isCopied, projectSelectCount, currentFolder]);

  useEffect(() => {
    fetchUnassignedDatasets();
  }, []);

  useEffect(() => {
    localStorage.setItem("projectViewType", viewType);
    setCheckedProjects([]);
    setCheckedFolders([]);
    setIsCreatingFolder(false);
  }, [viewType]);

  useEffect(() => {
    if (
      checkedProjects.length === projectsData.length &&
      checkedFolders.length === folderList.length &&
      (folderList.length !== 0 || checkedFolders.length !== 0)
    ) {
      setChecked(true);
    } else {
      setChecked(false);
    }
  }, [checkedFolders.length, checkedProjects, folderList.length, projectsData.length]);

  const fetchFolders = async (parentId: number) => {
    let folderId: number | undefined = undefined;
    try {
      if (parentId !== -1) {
        folderId = parentId;
      }
      const response = await getFoldersByPath(folderId);
      setFolderList(response.folders);
    } catch (error) {
      console.error(error);
    }
  };

  const fetchProjects = async () => {
    try {
      if (isCopied) {
        // 복제시 실행
        const response = await getProjects({
          folder: currentFolder.id !== -1 ? currentFolder.id : undefined,
        });
        setIsCopied(false);
        setTotalCount(response.projects.total);
        return;
      }

      const response = await getProjects({
        page,
        size: projectSelectCount,
        folder: currentFolder.id !== -1 ? currentFolder.id : undefined,
      });
      if (response.projects.data.total === 0) {
        setIsClick(true);
      }
      const existingIds = new Set(projectsData.map((project) => project.id));
      const newProjects = response.projects.data.filter((project: any) => !existingIds.has(project.id));
      setProjectsData((prev) => [...prev, ...newProjects]);
      setTotalCount(response.projects.total);
    } catch (error) {
      console.error(error);
    }
  };

  const fetchUnassignedDatasets = async () => {
    try {
      const response = await getUnassignedDataSets();
      setUnassignedDataset(response.dataSets);
      console.log(response.dataSets);
    } catch (error) {
      console.error(error);
    }
  };

  const handleMoreProject = () => {
    setPage(page + 1);
  };

  // 새 프로젝트 생성
  const handleNewProject = () => {
    navigate("/main/projects/create");
    // navigate("/projects/create");
    setSelectedProject(null);
    setAutoFillData([]);
    setIsClick(false);
  };

  // 새 폴더 생성 - input
  const handleNewFolder = () => {
    setIsCreatingFolder(true);
  };

  // 전체 선택 (폴더 및 프로젝트)
  const handleAllCheck = () => {
    if (checked) {
      //true일때 클릭: 전체 해제
      setCheckedProjects([]);
      setCheckedFolders([]);
    } else {
      setCheckedProjects(projectsData.map((project) => project.id));
      setCheckedFolders(folderList?.map((folder) => folder.id));
    }
    setChecked((prev) => !prev);
  };

  // 경로 뒤로가기
  const handleBack = async () => {
    const parts = currentPath.split("/").filter(Boolean); // 빈 문자열 제거
    // setCurrentFolderId(currentFolder.parent ? currentFolder.parent : -1);

    if (currentFolder.parent) {
      const response = await getFolder(currentFolder.parent);
      setCurrentFolder(response.folder);
    } else {
      setCurrentFolder({
        id: -1,
        name: "",
        parent: null,
      });
    }

    if (parts.length > 1) {
      const newPath = parts.slice(0, -1).join("/");
      setCurrentPath("/" + newPath);
    } else {
      // root까지 왔을 경우
      setCurrentPath("/root");
    }
  };

  // 폴더 및 파일 드래그 관련 함수: dragStart, dragEnd, dragMove, drop
  const handleDragStart = (e: React.DragEvent, item: string) => {
    setIsDragging(true);
    setDragInfo({
      name: item,
      count: checkedProjects.length + checkedFolders.length,
      x: e.clientX,
      y: e.clientY,
    });

    // drag 시 원래 요소 복사되는 ghost image 제거
    const img = new Image();
    img.src =
      "data:image/svg+xml;base64," + btoa('<svg xmlns="http://www.w3.org/2000/svg" width="0" height="0"></svg>');
    e.dataTransfer.setDragImage(img, 0, 0);

    document.addEventListener("dragover", handleDragMove);
  };

  const handleDragEnd = () => {
    setIsDragging(false);
    setDragInfo(null);
    document.removeEventListener("dragover", handleDragMove);
  };

  const handleDragMove = useCallback((e: DragEvent) => {
    setDragInfo((prev) => prev && { ...prev, x: e.clientX, y: e.clientY });
  }, []);

  const handleDrop = async (e: React.DragEvent, targetFolderId: number) => {
    e.preventDefault();
    await editFolderContents(targetFolderId, checkedFolders, checkedProjects);
    setProjectsData(projectsData.filter((project) => !checkedProjects.includes(project.id)));
    setFolderList(folderList.filter((folder) => !checkedFolders.includes(folder.id)));
    toast.success("해당 폴더로 이동을 완료했습니다.");
    setIsDragging(false);
    setDragInfo(null);
    setCheckedFolders([]);
    setCheckedProjects([]);
  };

  // 튜토리얼 콜백 함수
  const handleTourCallback = (data: any) => {
    const { status, index, type, action, lifecycle } = data;
    if (type === "step:after" && index === 0 && action === "next") {
      navigate(`/project/${step_1_project_id}`, {
        state: { continueTour: true },
      });
      setStepIndex((prev) => prev + 1);
    }
    if (status === status.FINISHED || status === status.SKIPPED || (action === "close" && lifecycle === "complete")) {
      setIsRun(false);
    }
  };

  const handleDeleteMultiple = async () => {
    try {
      let totalProjectCount = 0;
      for (const folderId of checkedFolders) {
        const response = await getFolderContents(folderId);
        totalProjectCount += response.projectList.length;
      }

      const message =
        totalProjectCount > 0
          ? `선택한 폴더 내에 ${totalProjectCount}개의 프로젝트가 존재합니다. 정말로 삭제하시겠습니까?`
          : checkedProjects.length > 0
            ? `정말로 선택한 파일 ${checkedProjects.length}개를 삭제하시겠습니까?`
            : "정말로 선택한 항목을 삭제하시겠습니까?";

      const confirmed = window.confirm(message);
      if (!confirmed) return;

      if (checkedFolders.length > 0) {
        await Promise.all(checkedFolders.map((id) => deleteFolder(id)));
        setFolderList((prev) => prev.filter((item) => !checkedFolders.includes(item.id)));
      }

      if (checkedProjects.length > 0) {
        await Promise.all(checkedProjects.map((id) => deleteProject(id)));
        console.log(checkedProjects);
        setProjectsData((prev) => prev.filter((item) => !checkedProjects.includes(item.id)));
      }

      setCheckedFolders([]);
      setCheckedProjects([]);
    } catch (error) {
      console.error(error);
      toast.error("삭제 중 오류가 발생했습니다.");
    }
  };

  const handleSelectChange = (e: SelectChangeEvent<string>) => {
    const value = e.target.value;
    setSelectType(value);
  };

  return (
    <PageShell title="프로젝트 관리" subtitle="프로젝트와 폴더를 생성하고 관리하세요">
      <div className="h-full flex flex-col overflow-hidden">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "0 20px",
            height: "52px",
            background: "var(--toolbar-bg, #ffffff)",
            borderBottom: "1px solid var(--toolbar-border, var(--dk-border, #e8eaed))",
            flexShrink: 0,
            gap: "10px",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
            <Checkbox
              checked={checked}
              onClick={handleAllCheck}
              size="small"
              sx={{
                p: "4px",
                color: "var(--checkbox-color, #9ca3af)",
                borderRadius: "6px",
                "&.Mui-checked": { color: "#3b82f6" },
              }}
            />
            <button
              id="new-project-btn"
              onClick={handleNewProject}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
                padding: "5px 12px",
                borderRadius: "7px",
                border: "1px solid var(--dk-border, #e2e8f0)",
                background: "var(--dk-surface, #fff)",
                cursor: "pointer",
                fontSize: "12px",
                fontWeight: 500,
                color: "var(--dk-text-2, #374151)",
                transition: "all .15s",
              }}
              onMouseEnter={(e) => {
                (e.currentTarget as HTMLElement).style.borderColor = "#3b82f6";
                (e.currentTarget as HTMLElement).style.color = "#3b82f6";
              }}
              onMouseLeave={(e) => {
                (e.currentTarget as HTMLElement).style.borderColor = "var(--dk-border, #e2e8f0)";
                (e.currentTarget as HTMLElement).style.color = "var(--dk-text-2, #374151)";
              }}
            >
              <span style={{ fontSize: 14 }}>＋</span> {t("NewProject")}
            </button>
            <button
              onClick={handleNewFolder}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
                padding: "5px 12px",
                borderRadius: "7px",
                border: "1px solid var(--dk-border, #e2e8f0)",
                background: "var(--dk-surface, #fff)",
                cursor: "pointer",
                fontSize: "12px",
                fontWeight: 500,
                color: "var(--dk-text-2, #374151)",
                transition: "all .15s",
              }}
              onMouseEnter={(e) => {
                (e.currentTarget as HTMLElement).style.borderColor = "#f59e0b";
                (e.currentTarget as HTMLElement).style.color = "#d97706";
              }}
              onMouseLeave={(e) => {
                (e.currentTarget as HTMLElement).style.borderColor = "var(--dk-border, #e2e8f0)";
                (e.currentTarget as HTMLElement).style.color = "var(--dk-text-2, #374151)";
              }}
            >
              <span style={{ fontSize: 13 }}>📁</span> {t("NewFolder")}
            </button>

            {(checkedProjects.length > 0 || checkedFolders.length > 0) && (
              <div style={{ display: "flex", alignItems: "center", gap: "6px", marginLeft: "4px" }}>
                <div style={{ width: "1px", height: "18px", background: "var(--dk-surface-3, #e2e8f0)" }} />
                <button
                  onClick={() => setOpen(true)}
                  style={{
                    padding: "5px 12px",
                    borderRadius: "7px",
                    border: "1px solid #ddd6fe",
                    background: "#f5f3ff",
                    cursor: "pointer",
                    fontSize: "12px",
                    fontWeight: 500,
                    color: "#7c3aed",
                    transition: "all .15s",
                  }}
                >
                  {t("Move")}
                </button>
                <button
                  onClick={handleDeleteMultiple}
                  style={{
                    padding: "5px 12px",
                    borderRadius: "7px",
                    border: "1px solid #fecaca",
                    background: "#fff5f5",
                    cursor: "pointer",
                    fontSize: "12px",
                    fontWeight: 500,
                    color: "#dc2626",
                    transition: "all .15s",
                  }}
                >
                  {t("Delete")}
                </button>
                <span
                  style={{
                    fontSize: "11px",
                    fontWeight: 600,
                    color: "var(--dk-text-2, #6b7280)",
                    padding: "3px 8px",
                    borderRadius: "20px",
                    background: "var(--dk-surface-2, #f3f4f6)",
                  }}
                >
                  {checkedFolders.length + checkedProjects.length}개 선택
                </span>
              </div>
            )}
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                background: "var(--dk-surface-2, #f3f4f6)",
                borderRadius: "8px",
                padding: "2px",
                gap: "1px",
              }}
            >
              {[
                { type: "grid", icon: <GridViewIcon sx={{ fontSize: 16 }} /> },
                { type: "list", icon: <ViewHeadlineIcon sx={{ fontSize: 16 }} /> },
              ].map(({ type, icon }) => (
                <button
                  key={type}
                  onClick={() => setViewType(type as any)}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "28px",
                    height: "28px",
                    borderRadius: "6px",
                    border: "none",
                    background: viewType === type ? "var(--dk-surface-3, #fff)" : "transparent",
                    color: viewType === type ? "#3b82f6" : "#9ca3af",
                    cursor: "pointer",
                    boxShadow: viewType === type ? "0 1px 3px rgba(0,0,0,0.1)" : "none",
                    transition: "all .15s",
                  }}
                >
                  {icon}
                </button>
              ))}
            </div>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "6px",
            padding: "0 20px",
            height: "36px",
            background: "var(--toolbar-bg, #ffffff)",
            borderBottom: "1px solid var(--toolbar-border, var(--dk-border, #e8eaed))",
            flexShrink: 0,
          }}
        >
          {currentPath !== "/root" && (
            <IconButton
              onClick={handleBack}
              size="small"
              sx={{
                width: 24,
                height: 24,
                borderRadius: "6px",
                color: "var(--dk-text-2, #6b7280)",
                "&:hover": { background: "var(--dk-surface-2, #f3f4f6)", color: "var(--dk-text, #111827)" },
              }}
            >
              <ArrowBackIcon sx={{ fontSize: 14 }} />
            </IconButton>
          )}
          <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
            {currentPath
              .split("/")
              .filter(Boolean)
              .map((segment, i, arr) => (
                <Fragment key={i}>
                  <span
                    style={{
                      fontSize: "12px",
                      color: i === arr.length - 1 ? "var(--dk-text, #111827)" : "var(--dk-text-3, #9ca3af)",
                      fontWeight: i === arr.length - 1 ? 500 : 400,
                    }}
                  >
                    {segment}
                  </span>
                  {i < arr.length - 1 && (
                    <span style={{ fontSize: "12px", color: "var(--dk-text-3, #d1d5db)" }}>/</span>
                  )}
                </Fragment>
              ))}
          </div>
          <div style={{ marginLeft: "auto", display: "flex", alignItems: "center", gap: "6px" }}>
            <span style={{ fontSize: "11px", color: "var(--dk-text-3, #9ca3af)" }}>
              {folderList?.length ?? 0}개 폴더 · {projectsData.length}개 프로젝트
            </span>
          </div>
        </div>
        <div style={{ flex: 1, overflow: "auto", padding: "16px 20px", background: "var(--toolbar-bg, #ffffff)" }}>
          {viewType === "grid" ? (
            <>
              <DatasetGridView datasetList={unassignedList} />
              <div style={{ marginTop: "8px" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    marginBottom: "10px",
                  }}
                >
                  <FolderIcon sx={{ fontSize: 14, color: "#f59e0b" }} />
                  <span
                    style={{
                      fontSize: "11px",
                      fontWeight: 600,
                      color: "var(--dk-text-2, #6b7280)",
                      textTransform: "uppercase",
                      letterSpacing: "0.06em",
                    }}
                  >
                    프로젝트 목록
                  </span>
                  <div
                    style={{ flex: 1, height: "1px", background: "var(--dk-surface-3, #e5e7eb)", marginLeft: "4px" }}
                  />
                </div>

                <div
                  id="main-card-list"
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fill, minmax(240px, 1fr))",
                    gap: "10px",
                  }}
                >
                  {isCreatingFolder && (
                    <NewFolderCard
                      setIsCreatingFolder={setIsCreatingFolder}
                      currentFolder={currentFolder}
                      setFolderList={setFolderList}
                    />
                  )}
                  {folderList?.map((folder) => (
                    <FolderCard
                      key={folder.id}
                      folder={folder}
                      folderList={folderList}
                      checkedProjects={checkedProjects}
                      checkedFolders={checkedFolders}
                      currentPath={currentPath}
                      setFolderList={setFolderList}
                      setCheckedProjects={setCheckedProjects}
                      setCheckedFolders={setCheckedFolders}
                      setCurrentPath={setCurrentPath}
                      setCurrentFolder={setCurrentFolder}
                      onDragStart={handleDragStart}
                      onDragEnd={handleDragEnd}
                      onDrop={handleDrop}
                      setOpenFolderInfo={setOpenFolderInfo}
                    />
                  ))}
                  {projectsData.map((project) => (
                    <ProjectCard
                      key={project.id}
                      data={project}
                      projectData={projectsData}
                      checkedProjects={checkedProjects}
                      setProjectsData={setProjectsData}
                      setCheckedProjects={setCheckedProjects}
                      setIsCopied={setIsCopied}
                      onDragStart={handleDragStart}
                      onDragEnd={handleDragEnd}
                      className={`project-card-${project.id}`}
                      setDeletedId={() => {}}
                    />
                  ))}
                </div>
              </div>
            </>
          ) : (
            <div
              style={{
                background: "var(--dk-surface, #fff)",
                borderRadius: "10px",
                border: "1px solid var(--dk-border, #e5e7eb)",
                overflow: "hidden",
              }}
            >
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "40px 40px 220px 110px 170px 140px 140px 1fr",
                  alignItems: "center",
                  padding: "0 16px",
                  height: "36px",
                  background: "var(--dk-surface-2, #f9fafb)",
                  borderBottom: "1px solid var(--dk-border, #e5e7eb)",
                }}
              >
                {["", "종류", "이름", "타입", "자재", "라벨링 개수", "총 이미지 개수", "생성일자"].map((label, i) => (
                  <span
                    key={i}
                    style={{
                      fontSize: "11px",
                      fontWeight: 600,
                      color: "var(--dk-text-3, #9ca3af)",
                      textTransform: "uppercase",
                      letterSpacing: "0.05em",
                    }}
                  >
                    {label}
                  </span>
                ))}
              </div>

              <List disablePadding>
                {isCreatingFolder && (
                  <NewFolderListItem
                    setIsCreatingFolder={setIsCreatingFolder}
                    currentFolder={currentFolder}
                    setFolderList={setFolderList}
                  />
                )}
                <ListView
                  checkedProjects={checkedProjects}
                  checkedFolders={checkedFolders}
                  setCheckedFolders={setCheckedFolders}
                  setCheckedProjects={setCheckedProjects}
                  setCurrentFolder={setCurrentFolder}
                  currentPath={currentPath}
                  setCurrentPath={setCurrentPath}
                  folderList={folderList}
                  setFolderList={setFolderList}
                  onDragStart={handleDragStart}
                  onDragEnd={handleDragEnd}
                  onDrop={handleDrop}
                  setProjectsData={setProjectsData}
                  projectsData={projectsData}
                  setIsCopied={setIsCopied}
                  setOpenFolderInfo={setOpenFolderInfo}
                />
              </List>
            </div>
          )}
          {projectsData.length < totalCount && (
            <div style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
              <button
                onClick={handleMoreProject}
                style={{
                  padding: "8px 24px",
                  borderRadius: "8px",
                  border: "1px solid var(--dk-border, #e2e8f0)",
                  background: "var(--dk-surface, #fff)",
                  fontSize: "13px",
                  fontWeight: 500,
                  color: "var(--dk-text-2, #374151)",
                  cursor: "pointer",
                  transition: "all .15s",
                }}
                onMouseEnter={(e) => {
                  (e.currentTarget as HTMLElement).style.borderColor = "#3b82f6";
                  (e.currentTarget as HTMLElement).style.color = "#3b82f6";
                }}
                onMouseLeave={(e) => {
                  (e.currentTarget as HTMLElement).style.borderColor = "var(--dk-border, #e2e8f0)";
                  (e.currentTarget as HTMLElement).style.color = "var(--dk-text-2, #374151)";
                }}
              >
                {t("More")}
              </button>
            </div>
          )}
        </div>

        {isDragging && dragInfo && (
          <div
            style={{
              position: "fixed",
              top: dragInfo.y + 12,
              left: dragInfo.x + 12,
              zIndex: 2000,
              pointerEvents: "none",
              padding: "6px 12px",
              borderRadius: "8px",
              background: "var(--dk-surface-glass, rgba(255,255,255,0.95))",
              border: "1px solid var(--dk-border, #e2e8f0)",
              boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <span style={{ fontSize: "13px", fontWeight: 600, color: "var(--dk-text, #111827)" }}>
              {dragInfo.name}
            </span>
            {dragInfo.count > 1 && (
              <span
                style={{
                  fontSize: "11px",
                  fontWeight: 700,
                  padding: "2px 7px",
                  borderRadius: "20px",
                  background: "#3b82f6",
                  color: "#fff",
                }}
              >
                +{dragInfo.count - 1}
              </span>
            )}
          </div>
        )}

        {open && (
          <FolderModal
            open={open}
            setOpen={setOpen}
            checkedProjects={checkedProjects}
            checkedFolders={checkedFolders}
            projectsData={projectsData}
            setProjectsData={setProjectsData}
            folderList={folderList}
            setFolderList={setFolderList}
          />
        )}
      </div>
    </PageShell>
  );
}

interface NewFolderCardProps {
  setIsCreatingFolder: (isCreated: boolean) => void;
  currentFolder: FolderItem;
  setFolderList: Dispatch<SetStateAction<FolderItem[]>>;
}

const NewFolderCard = ({ setIsCreatingFolder, currentFolder, setFolderList }: NewFolderCardProps) => {
  const [newFolderName, setNewFolderName] = useState<string>("");
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const handleContextMenu = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    setAnchorEl(event.currentTarget);
  };

  const saveFolder = async () => {
    if (newFolderName.trim() === "") {
      setIsCreatingFolder(false);
      return;
    }

    try {
      let parentId = currentFolder.id === -1 ? null : currentFolder.id;
      const response = await createFolder(newFolderName.trim(), parentId);
      setFolderList((prev) => [...prev, response.newFolder]);
      setIsCreatingFolder(false);
    } catch (error: any) {
      toast.error(error.message);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      e.preventDefault();
      saveFolder();
    }
  };

  return (
    <div
      style={{
        background: "var(--dk-surface, #fff)",
        borderRadius: "10px",
        border: "2px dashed #93c5fd",
        padding: "14px",
        cursor: "pointer",
        animation: "fadeIn .15s ease-out",
      }}
      onContextMenu={handleContextMenu}
    >
      <div style={{ display: "flex", alignItems: "flex-start", gap: "10px" }}>
        <div
          style={{
            width: 36,
            height: 36,
            borderRadius: "8px",
            background: "var(--dk-info-bg, #eff6ff)",
            flexShrink: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Folder style={{ color: "#3b82f6", fontSize: 20 }} size={20} />
        </div>
        <TextField
          size="small"
          autoFocus
          value={newFolderName}
          onChange={(e) => setNewFolderName(e.target.value)}
          onKeyDown={handleKeyDown}
          onBlur={saveFolder}
          placeholder="폴더 이름 입력"
          sx={{
            flex: 1,
            "& .MuiOutlinedInput-root": {
              fontSize: "13px",
              borderRadius: "7px",
              "& fieldset": { borderColor: "var(--dk-info-border, #bfdbfe)" },
              "&:hover fieldset": { borderColor: "#93c5fd" },
              "&.Mui-focused fieldset": { borderColor: "#3b82f6" },
            },
          }}
        />
      </div>
      <p style={{ fontSize: "11px", color: "var(--dk-text-3, #9ca3af)", marginTop: "8px", marginLeft: "46px" }}>
        Enter로 저장 · Esc로 취소
      </p>
    </div>
  );
};

interface NewFolderListItemProps {
  setIsCreatingFolder: (val: boolean) => void;
  currentFolder: FolderItem;
  setFolderList: React.Dispatch<React.SetStateAction<FolderItem[]>>;
}

const NewFolderListItem = ({ setIsCreatingFolder, currentFolder, setFolderList }: NewFolderListItemProps) => {
  const [newFolderName, setNewFolderName] = useState("");

  const handleKeyDown = async (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      try {
        const parentId = currentFolder.id === -1 ? null : currentFolder.id;
        const response = await createFolder(newFolderName, parentId);
        setFolderList((prev) => [...prev, response.newFolder]);
        setIsCreatingFolder(false);
      } catch (error: any) {
        toast.error(error.message);
      }
    } else if (e.key === "Escape") {
      setIsCreatingFolder(false);
    }
  };

  return (
    <ListItem
      sx={{
        display: "flex",
        alignItems: "center",
        py: "8px",
        px: "16px",
        borderBottom: "1px solid var(--dk-border, #f3f4f6)",
        background: "#f0f9ff",
        gap: "10px",
      }}
    >
      <Checkbox edge="start" disabled size="small" sx={{ color: "var(--dk-text-3, #d1d5db)", p: "2px" }} />
      <div
        style={{
          width: 28,
          height: 28,
          borderRadius: "6px",
          background: "var(--dk-info-bg, #eff6ff)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
        }}
      >
        <FolderIcon sx={{ fontSize: 16, color: "#3b82f6" }} />
      </div>
      <TextField
        value={newFolderName}
        onChange={(e) => setNewFolderName(e.target.value)}
        onKeyDown={handleKeyDown}
        autoFocus
        size="small"
        placeholder="새 폴더 이름 입력"
        sx={{
          flex: 1,
          "& .MuiOutlinedInput-root": {
            fontSize: "13px",
            borderRadius: "7px",
            height: "32px",
            "& fieldset": { borderColor: "var(--dk-info-border, #bfdbfe)" },
            "&.Mui-focused fieldset": { borderColor: "#3b82f6" },
          },
        }}
      />
      <span style={{ fontSize: "11px", color: "var(--dk-text-3, #9ca3af)", whiteSpace: "nowrap" }}>
        Enter 저장 · Esc 취소
      </span>
    </ListItem>
  );
};
